module.exports = __webpack_public_path__ + "male_names.680546d2e86592c8c68b3ecc33d178f7.json";